export const navigateSecurely = (navigate, path, additionalState = {}) => {
  const token = `access-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
  sessionStorage.setItem('routeAccessToken', token)
  
  navigate(path, {
    state: {
      fromApp: true,
      token,
      ...additionalState,
    },
  })
}

export const navigateAwaySecurely = (navigate, path, options = {}) => {
  navigate(path, { ...options, replace: true })
}

export const isNavigationAuthorized = (locationState) => {
  const hasValidState = locationState?.fromApp === true
  const token = sessionStorage.getItem('routeAccessToken')
  const stateToken = locationState?.token
  
  return hasValidState && token && token === stateToken
}

export const clearNavigationAuth = () => {
  sessionStorage.removeItem('routeAccessToken')
}

export const getRedirectRouteByRole = (roleId, fallback = '/visits') => {
  if (roleId === 11) {
    return '/approval-management'
  }
  return fallback
}
